var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#009dcf",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,4c-6.617,0 -12,7.27 -12,16.205c0,4.834 1.582,9.169 4.078,12.136c-0.048,0.213 -0.078,0.432 -0.078,0.659c0,1.657 1.343,3 3,3c1.657,0 3,-1.343 3,-3c0,-1.657 -1.343,-3 -3,-3c-0.315,0 -0.612,0.062 -0.897,0.152c-1.897,-2.421 -3.103,-5.977 -3.103,-9.947c0,-7.281 4.037,-13.205 9,-13.205c3.837,0 7.111,3.547 8.404,8.518c1.122,0.346 2.237,0.782 3.33,1.308c-1.155,-7.318 -5.975,-12.826 -11.734,-12.826z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.507,20.084c-3.947,-2.392 -8.374,-3.442 -12.182,-2.959c-0.55,-0.681 -1.382,-1.125 -2.325,-1.125c-1.657,0 -3,1.343 -3,3c0,1.657 1.343,3 3,3c1.272,0 2.353,-0.795 2.789,-1.912c3.118,-0.379 6.812,0.531 10.163,2.563c6.403,3.881 9.67,10.569 7.282,14.911c-0.827,1.504 -2.286,2.572 -4.218,3.09c-2.286,0.611 -5.007,0.394 -7.727,-0.528c-0.839,0.772 -1.749,1.498 -2.725,2.168c2.552,1.117 5.196,1.704 7.669,1.704c1.24,0 2.438,-0.147 3.559,-0.447c2.741,-0.733 4.841,-2.304 6.071,-4.542c3.153,-5.731 -0.596,-14.22 -8.356,-18.923z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,28.992c0,-1.652 -1.343,-2.992 -3,-2.992c-1.657,0 -3,1.34 -3,2.992c0,0.669 0.228,1.281 0.6,1.779c-1.279,2.802 -3.744,5.567 -7.062,7.578c-3.865,2.344 -8.185,3.202 -11.555,2.302c-1.932,-0.518 -3.391,-1.586 -4.218,-3.09c-1.702,-3.094 -0.521,-7.376 2.61,-10.988c-0.323,-1.144 -0.562,-2.34 -0.706,-3.575c-5.07,4.797 -7.109,11.323 -4.532,16.009c1.23,2.238 3.33,3.809 6.071,4.542c1.121,0.3 2.318,0.447 3.559,0.447c3.346,0 7.007,-1.068 10.326,-3.08c3.836,-2.325 6.683,-5.577 8.209,-8.962c1.513,-0.153 2.698,-1.413 2.698,-2.962z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.b260337e716c6197c2f4dcc9cefe5862.svg";
export { ForwardRef as ReactComponent };